import React from "react";

interface BenchIconBackgroundProps {
  icon: React.ReactNode;
  bgColor?: string;
  size?: number;
  padding?: string | number;
}

const BenchIconBackground: React.FC<BenchIconBackgroundProps> = ({
  icon,
  bgColor = "#FFF6F8", // default light red
  size = 32,
  padding = 6,
}) => {
  return (
    <div
      style={{
        backgroundColor: bgColor,
        borderRadius: "50%",
        padding: padding,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
      }}
    >
      {icon}
    </div>
  );
};

export default BenchIconBackground;
